import React from 'react';

const HousePentagonIcon = ({ width = 15, height = 15, fill = 'none' }) => (
  <svg
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
  >
    <path
      opacity="0.5"
      d="M13.643 7.43379L7.34297 1.13379L1.04297 7.43379V12.3338C1.04297 12.7051 1.19047 13.0612 1.45302 13.3237C1.71557 13.5863 2.07167 13.7338 2.44297 13.7338H12.243C12.6143 13.7338 12.9704 13.5863 13.2329 13.3237C13.4955 13.0612 13.643 12.7051 13.643 12.3338V7.43379Z"
      stroke="black"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HousePentagonIcon;
